export async function fetchGravatarUrl(email: string): Promise<string | null> {
  const data = new TextEncoder().encode(email.trim().toLowerCase());
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hash = Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  const url = `https://www.gravatar.com/avatar/${hash}?d=404&s=80`;
  const res = await fetch(url, { method: "HEAD" });
  return res.ok ? url : null;
}
